/**
 * PlayerDisplayProperty.js client-side code
 *
 * @package   Freecaster freecaster/luna/player
 * @author    François Arki <francois.arki@freecaster.com>
 * @copyright (c) 2019 Freecaster SPRL
 */
import { PlayerProperty } from '../PlayerProperty'

class PlayerDisplayProperty extends PlayerProperty {
  /**
   *
   * @param player
   * @param {ServerEvent} value
   */
  handle (player, value) {
    const playerDisplayFlowPlayerFeature = player.fc_features.get('PlayerDisplayFlowPlayerFeature')

    if (value.target.attributes && Object.keys(value.target.attributes).length > 0)
      return playerDisplayFlowPlayerFeature.addOrUpdate(value.target.attributes)

    playerDisplayFlowPlayerFeature.remove()
  }

  getName () {
    return 'player_display'
  }
}

export const playerDisplayProperty = new PlayerDisplayProperty()
